// @flow

import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import "./SiteNavigation.css";

type Props = {};

class SiteNavigation extends Component<Props> {
  render() {
    return (
      <div className="SiteNavigation">
        <NavLink to="/results" activeClassName="active">
          Your Results
        </NavLink>
      </div>
    );
  }
}

export default SiteNavigation;



// WEBPACK FOOTER //
// ./src/components/SiteNavigation/SiteNavigation.js